export default "__VITE_ASSET__DiyRVhrl__"